import React, {Component} from 'react';
import AllowOpposingPitchers from './allow-opposing-pitchers';
import PitchersQuantity from './pitchers-quantity';

class OpposingPitchers extends Component {
    render() {
        return (
            <div className="gap-y">
                <AllowOpposingPitchers />

                <div className="form-inline">
                    <span className="form-sub-text">from</span>
                    <PitchersQuantity boundaryName={'min'} />
                    <span className="form-sub-text">to</span>
                    <PitchersQuantity boundaryName={'max'} />
                </div>
            </div>
        );
    }
}

export default OpposingPitchers;
